import {createFileRoute} from '@tanstack/react-router';

import patientSignUp from '@/anonymous/views/PatientSignUp';

export const Route = createFileRoute('/(anonymous)/patient-signup')({
  component: patientSignUp
});
